/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListPresetsPresetType = typeof ListPresetsPresetType[keyof typeof ListPresetsPresetType] | null;


export const ListPresetsPresetType = {
  companies: 'companies',
  universities: 'universities',
  job_titles: 'job_titles',
  skills: 'skills',
  investors: 'investors',
  locations: 'locations',
  filters: 'filters',
  job_stages: 'job_stages',
} as const;
